import { useEffect } from "react";

import { useWidget } from "/imports/state/WidgetContext";
import { useAuth } from "/imports/state/AuthContext";
import { isStandalone, markInstalled, syncDevice } from "/imports/libs/push";
import { track } from "/imports/libs/analytics";

/**
 * On every open while signed in, keeps the API's record of this phone current:
 * marks it seen, rebinds it to whoever just signed in on a shared phone, and
 * re-registers a subscription the browser rotated. Only for a club this phone
 * was turned on for — asking is the prompt card's job, never this.
 */
function PushSync() {
  const { slug, push } = useWidget();
  const { user } = useAuth();
  const userId = user?._id || null;
  const enabled = !!push?.enabled && !!push?.publicKey;

  // Opened from the Home Screen: remember the app is installed, so the browser on
  // the same phone stops offering it, and count the open — the one install
  // measure that works on every phone, iPhone included.
  useEffect(() => {
    if (!slug || !isStandalone()) return;
    markInstalled(slug);
    track("app_opened");
  }, [slug]);

  useEffect(() => {
    if (!slug || !userId || !enabled) return;
    // Background upkeep: a failure here is retried on the next open, so it is
    // logged rather than shown — the user didn't ask for anything.
    syncDevice({ slug, publicKey: push.publicKey }).catch((err) => console.warn("Push sync failed:", err?.message));
  }, [slug, userId, enabled, push?.publicKey]);

  return null;
}

export default PushSync;
